import React from "react";
import { SimpleForm, TextInput } from "react-admin";

export const PlanForm = (props) => (
  <SimpleForm {...props}>
    <TextInput label="Nome" source="name" />
  </SimpleForm>
);
